// extracted by mini-css-extract-plugin
export default {"gap_50":"SingleProductPage_gap_50__AVgPe","full_width":"SingleProductPage_full_width__0usox"};